import { Directive, HostListener, Inject } from '@angular/core';
import { AsyncData } from '@cigna/shared/angular/core/interfaces-util';
import { map, startWith, take, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { WindowService } from '@cigna/shared/angular/core/window-util';
import {
  GatewayConfig,
  SHARED_GATEWAY_CONFIG,
} from '@cigna/shared/angular/gateways-util';

interface DownloadParams {
  link: string;
  target: string;
}

@Directive({
  selector: '[cignaSecureDocs]',
})
export class SecureDocsDirective {
  cdnPath = this._config.cdn.replace(/\/$/, '');

  constructor(
    private _http: HttpClient,
    @Inject(DOCUMENT) private _document: Document,
    private _window: WindowService,
    @Inject(SHARED_GATEWAY_CONFIG) private _config: GatewayConfig,
  ) {}

  @HostListener('click', ['$event']) onclick(event: MouseEvent | TouchEvent) {
    const target = event.target as HTMLAnchorElement;
    const link = target.href;
    if (
      this.cdnPath &&
      target.nodeName.toLowerCase() === 'a' &&
      link?.startsWith(`${this.cdnPath}/secure`)
    ) {
      event.preventDefault();
      this._http
        .get(link, { responseType: 'blob' })
        .pipe(
          take(1),
          map((response) => this._window.createObjectURL(response)),
          tap((href) =>
            this.handleDownload(
              { link, target: target.target || '_self' },
              href,
            ),
          ),
          map((href) => new AsyncData<string, Error>(true, href)),
          startWith(new AsyncData<string, Error>(false)),
        )
        .subscribe();
    }
  }

  private handleDownload(params: DownloadParams, href: string) {
    const anchorElement = this._document.createElement('a');
    const filename = params.link.substring(params.link.lastIndexOf('/') + 1);
    anchorElement.href = href;
    anchorElement.target = params.target;
    anchorElement.setAttribute('download', filename);
    this._document.body.appendChild(anchorElement);
    anchorElement.click();
    this._document.body.removeChild(anchorElement);
  }
}
